

import { Component, Mixins } from "vue-property-decorator";
import IBFlag from "@/components/Flags/Flag.vue";
import { Getter } from "vuex-class";
import { LANG_MODULE_NAME } from "@/store/modules/lang";
import { TLang } from "@/models/modules/lang/interface";
import { IListItem } from "@/models/core/core";
import langMethods from "@/models/modules/lang";
import I18nToSelectItems from "@/mixins/i18n-to-select-items";
import ContactInfoFormatter from "@/mixins/contact/ContactInfoFormatter";

@Component({
	components: {
		IBFlag
	}
})
export default class IBAsideAuth extends Mixins(
	I18nToSelectItems,
	ContactInfoFormatter
) {

	public isMenu: boolean;

	langs: IListItem[] = [];

	constructor() {
		super();

		this.isMenu = false;
	}

	@Getter("lang", { namespace: LANG_MODULE_NAME })
	lang!: TLang;

	created() {
		this.setSelectItems("langs", "langs");
	}

	menuOpen() {
		this.isMenu = !this.isMenu;
	}

	onLang(key: TLang) {
		langMethods.setLang(key);
		this.isMenu = false;
	}

}

